import { toast } from 'react-toastify';
import dateFormat from 'dateformat';

const Toast = {
    Default: (message) => {
        toast(message, {
            position: toast.POSITION.TOP_RIGHT
        });
    },
    Success: (message) => {
        toast.success(message, {
            position: toast.POSITION.TOP_RIGHT
        });
    },
    Error: (message) => {
        toast.error(message, {
            position: toast.POSITION.TOP_RIGHT
        });
    },
    Info: (message) => {
        toast.info(message, {
            position: toast.POSITION.TOP_RIGHT
        });
    },
    Warning: (message) => {
        toast.warn(message, {
            position: toast.POSITION.TOP_RIGHT
        })
    }

}
const Basic = {
    CopyTo: (src, dest) => {
        let key;
        for (key in src) {
            try {
                dest[key] = src[key];    
            } catch (error) {
                console.log("Error while copying object -"+error);
            }
            
        }
    }
}
const Dates = {
    ToString: (format, date) => {
        if (date === undefined || date === null) {
            date = new Date();
        }
        return dateFormat(date, format);
    },
    ToJsonDate: (date) => {
        if (date === undefined || date === null) {
            date = new Date();
        }
        return dateFormat(date, "isoUtcDateTime");
    }
}
const Cookies = {
    Create(name, value, days) {
        var expires;
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        }
        else expires = "";
        document.cookie = name + "=" + value + expires + "; path=/";
    },
    Read(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    Delete(name) {
        Cookies.Create(name, "", -1);
    }
}
export default {
    Toast,
    Dates,
    Basic,
    Cookies
}


// WEBPACK FOOTER //
// ./src/Utils.js